export enum SettingsType {
  WORKSPACE_ID,
  PROFILE_ID,
  STYLE_DEFINITION,
  LOGIN_URL_CALLBACK,
  ENVIRONMENT,
  API_HOST,
}
